export default __webpack_public_path__ + "static/media/cotton-candy-logo.d137da5d.jpeg";